/* Copyright (c) 2021 Caring Transitions Online Auctions. All Rights Reserved. */

// import moment from 'moment';
import moment from 'moment-timezone';
import React, { Component } from 'react';


// captalizes all the words in the given content
export const allWordsInCaps = (content) => {
    return content.replace(/\b\w/g, l => l.toUpperCase());
};

// formats mobile number to U.S standard 
export const mobileNumberFormat = (value, previousValue, firstTime = false) => {
    if (firstTime) {
        return value.replace(/\D+/g, '').replace(/(\d{3})(\d{3})(\d{4})/, '($1) $2-$3');
    }
    if (!value) return value;
    const currentValue = value.replace(/[^\d]/g, '');
    const cvLength = currentValue.length;

    if (!previousValue || value.length > previousValue.length) {
        if (cvLength < 4) return currentValue;
        if (cvLength < 7) return `(${currentValue.slice(0, 3)}) ${currentValue.slice(3)}`;
        return `(${currentValue.slice(0, 3)}) ${currentValue.slice(3, 6)}-${currentValue.slice(6, 10)}`;
    }
};

/**
 * formats date time to U.S standard
 *
 * @param {string} dateTime the date to be formated
 * 
 * @param {boolean} timeOnly (optional) defaults to false, when provided true will return time only
 * 
 * @returns formated date
 *  
 **/
export const dateTimeFormat = (dateTime, timeOnly = false) => {
    const formatedDate = moment.utc(dateTime).local();
    let returnValue = formatedDate.format('MM/DD/YYYY');
    if (timeOnly) {
        returnValue = formatedDate.format('LTS')
    }

    return returnValue + ' ' + moment.tz(moment.tz.guess()).zoneAbbr();
};

export const numberOfCloumn = () => {
    const innerWidth = window.innerWidth;
    return innerWidth < 1025 ? 2 : innerWidth >= 1707 ? 3 : 3;

}

export const stringToHTMLConvert = (provenance) => {
    try {
    const temp = JSON.parse(provenance);
    let htmlString = temp['content']['body'];

    const tempDiv = document.createElement('div');
    tempDiv.innerHTML = htmlString;

    const imageTags = tempDiv.querySelectorAll('img');

    imageTags.forEach((img, index) => {
      img.alt = `description-image`;
    });

    htmlString = tempDiv.innerHTML;

    return htmlString;
    } catch (e) {
        return provenance;
    }
}

export const SideBarHandle = (add = true) => {
    const sideBar = document.querySelector('.sidebar-box');
    if (sideBar) {
        if (add) {
            sideBar.classList.add('mt5');
        } else {
            sideBar.classList.remove('mt5');
        }
    }
}

/**
 * Converting data into ascending order (or) descending order
 * 
 * @param {Array} arrayValue The array to sort
 * 
 * @param {string} field Based on this array value will sort
 * 
 * @param {boolean} ascending Ascending or descending
 * 
 * @returns Converted data
 */
export const ArrayValueReorder = (arrayValue, field = null, ascending = true) => {

    const ascendingOrder = field ? [].concat(arrayValue).sort((a, b) => a[field].toLowerCase() > b[field].toLowerCase() ? 1 : -1) : [].concat(arrayValue).sort((a, b) => a.toLowerCase() > b.toLowerCase() ? 1 : -1);

    const descendingOrder = [].concat(ascendingOrder).reverse();

    return ascending ? ascendingOrder : descendingOrder;
}

/**
 * 
 * Count down 
 * 
 * @param {Date} endtime 
 * 
 * @param {Date} expirationDate 
 * 
 * @param {boolean} addSecs Default is true. To stop time set false.
 * 
 * @param {string} nowTime will use this time instance of UTC.
 * 
 * @returns duration and expiration Date
 */
export const getCountDown = (endtime, expirationDate, addSecs = true, nowTime = null) => {
    const now = nowTime ? nowTime : moment.utc();
    const secs = expirationDate.diff(now, 'seconds');
    const expirationCheck = secs < 1 ? addSecs ? moment.utc().add(30, 'seconds') : moment.utc() : expirationDate;
    const isBefore = moment.utc(endtime).isBefore(now);
    const expiration = isBefore ? addSecs ? expirationCheck : nowTime ? nowTime : moment.utc().add(5, 'seconds') : moment.utc(endtime);

    // get the difference between the moments
    const diff = expiration.diff(now);

    //express as a duration
    const diffDuration = moment.duration(diff);
    const min_diff = diffDuration.asMinutes();
    const duration_bg_color = min_diff < 5 ? "danger" : min_diff < 30 ? "warning" : "normal";
    const final = { expiration, diffDuration, isBefore, duration_bg_color };
    return final;
}

/**
 * 
 * Duration Bg
 * 
 * @param {Date} endtime 
 * 
 * @param {Date} expirationDate 
 * 
 * @returns Duration bg color
 */
export const getDurationBgColor = (endtime, expirationDate, addSecs = true, nowTime = null) => {
    const now = nowTime ? nowTime : moment.utc();
    const secs = expirationDate.diff(now, 'seconds');
    const expirationCheck = secs < 1 ? addSecs ? moment.utc().add(30, 'seconds') : moment.utc() : expirationDate;
    const isBefore = moment.utc(endtime).isBefore(now);
    const expiration = isBefore ? addSecs ? expirationCheck : nowTime ? nowTime : moment.utc().add(5, 'seconds') : moment.utc(endtime);

    // get the difference between the moments
    const diff = expiration.diff(now);

    //express as a duration
    const diffDuration = moment.duration(diff);

    // Get bg color
    const min_diff = diffDuration.asMinutes();
    const duration_bg_color = min_diff < 5 ? "danger" : min_diff < 30 ? "warning" : "normal";
    return duration_bg_color;
}

/**
 * 
 * Number of days in word
 * 
 * @param {Date} endtime 
 * 
 * @param {Date} expirationDate 
 * 
 * @returns number days 
 */
export const getNumberDaysInWord = (endtime, expirationDate, dontAdd = true) => {
    const now = moment.utc();
    const secs = expirationDate.diff(now, 'seconds');
    const expirationCheck = secs < 1 ? moment.utc().add(30, 'seconds') : expirationDate;
    const isBefore = moment.utc(endtime).isBefore(now);
    const expiration = isBefore ? expirationCheck : moment.utc(endtime);

    // get the difference between the moments
    const diff = expiration.diff(now);

    //express as a duration
    const diffDuration = moment.duration(diff);
    const isToday = diffDuration.asDays() < 1;
    const diff_days = parseFloat(diffDuration.asDays()).toFixed(0);
    let final = 'Starts closing in';
    if (!dontAdd) {
        const lastText = isToday ? 'today' : `${diff_days} days`;
        final = `${final} ${lastText}`
    }
    const returnValue = { final, isBefore, isToday, diff_days };
    return returnValue;
}

/**
 * 
 * Single to Two Digit convert 
 * 
 * @param {Number} n 
 * 
 * @returns Two digits 
 */
export const minTwoDigits = (n) => {
    return (n < 10 ? '0' : '') + n;
}

/**
 * 
 * @param {number} n 
 * 
 * @returns object
 * 
 */
export const ConvertSectoDay = (n) => {

    const seconds = Number(n);
    var d = Math.floor(seconds / (3600 * 24));
    var h = Math.floor(seconds % (3600 * 24) / 3600);
    var m = Math.floor(seconds % 3600 / 60);
    var s = Math.floor(seconds % 60);

    // Is closing today check
    const isClosingToday = parseFloat(parseFloat(d).toFixed(0)) === 0 && parseFloat(parseFloat(h).toFixed(0)) === 0;

    const final = {
        days: parseFloat(parseFloat(d).toFixed(0)),
        hours: parseFloat(parseFloat(h).toFixed(0)),
        minutes: parseFloat(parseFloat(m).toFixed(0)),
        seconds: parseFloat(parseFloat(s).toFixed(0)),
        isClosingToday
    };

    return final;
}

/**
 * 
 * @param {{itemArray: array, key: string}} source 
 * 
 * @param {{sortingArray: array, key: string}} destination 
 * 
 * @returns array
 */
export const sortByList = (source, destination) => {
    const res = source.itemArray.sort((a, b) => {
        return destination.sortingArray.map(x => x[destination.key]).indexOf(a[source.key]) - destination.sortingArray.map(x => x[destination.key]).indexOf(b[source.key]);
    });
    return res;
}

/**
 * 
 * @param {number} days This is float number
 * @returns return number without rounding
 */

export const getDays = (days) => {
    const dayString = days.toString().split('.');
    const numberValue = Number(dayString[0]);
    return numberValue;
}


/**
 * Capitalize the first letter of each word
 * 
 * @param {string} str 
 * 
 * @returns string
 */
export const titleCase = (str) => {
    if (!str) {
        return str;
    }
    var splitStr = str.toLowerCase().split(' ');
    for (var i = 0; i < splitStr.length; i++) {
        // You do not need to check if i is larger than splitStr length, as your for does that for you
        // Assign it back to the array
        splitStr[i] = splitStr[i].charAt(0).toUpperCase() + splitStr[i].substring(1);
    }
    // Directly return the joined string
    return splitStr.join(' ');
}

/**
 * 
 * Format Credit card number to standard
 * 
 */

export const creditCardNumberFormat = (cardNumber) => {

    // Do not allow users to write invalid characters
    var formattedCardNumber = cardNumber.replace(/[^\d]/g, "");
    formattedCardNumber = formattedCardNumber.substring(0, 16);

    // Split the card number is groups of 4
    var cardNumberSections = formattedCardNumber.match(/\d{1,4}/g);
    if (cardNumberSections !== null) {
        formattedCardNumber = cardNumberSections.join(' ');
    }

    return formattedCardNumber;
}

/**
 * 
 * Format credit card expiry date to standard
 * 
 */
export const creditCardDateFormat = (date) => {
    const expdate = date;
    const expDateFormatter = expdate.replace(/[^\d]/g, "").substring(0, 2) +
        (expdate.length > 2 ? '/' : '') +
        expdate.replace(/[^\d]/g, "").substring(2, 6);

    return expDateFormatter;
}

/** 
 * 
 * Format credit card CVV.
 * 
 */

export const creditCardCVVFormat = (cvv) => {
    return cvv.replace(/[^\d]/g, "");
}

  
  